import type { ComponentPropsWithRef, ReactNode } from "react";
import { forwardRef } from "react";
import { Column, Row, Section } from "@react-email/components";
import { BlockSection } from "@/react/components/shared/BuilderUI/BlockSection";
import type { StyleValue } from "@circle-react-shared/BuilderUI/StyleValue.types";
import { useGoober } from "../../../Design/GooberContext";
import { mobileMediaQuery } from "../../../Design/mediaQuery";
import { useTopBlockStyles } from "../../../Design/useTopBlockStyles";
import { SectionContainer } from "../../../Utils/SectionContainer";
import { defaultStyles } from "./defaultStyles";

export interface HeroBlock3Props extends ComponentPropsWithRef<"table"> {
  headerContent?: ReactNode;
  imageContent?: ReactNode;
  primaryButton?: ReactNode;
  styles?: Record<string, StyleValue>;
}

export const HeroBlock3 = forwardRef<HTMLTableElement, HeroBlock3Props>(
  ({ headerContent, primaryButton, imageContent, styles, ...rest }, ref) => {
    const { css } = useGoober();
    const { backgroundStyles, paddingStyles, marginStyles } = useTopBlockStyles(
      {
        styles,
        defaultStyles,
        ignoreDefaults: false,
      },
    );

    return (
      <SectionContainer cssProperties={marginStyles}>
        <Section
          ref={ref}
          style={{
            ...backgroundStyles,
            ...paddingStyles,
          }}
          {...rest}
        >
          <Row>
            <Column
              width="50%"
              className={css`
                ${mobileMediaQuery} {
                  display: block;
                  width: 100% !important;
                  padding-right: 0 !important;
                  padding-bottom: 48px;
                }
              `}
            >
              {imageContent}
            </Column>
            <Column
              width="50%"
              className={css`
                ${mobileMediaQuery} {
                  display: block;
                  width: 100%;
                  padding-left: 0 !important;
                }
              `}
            >
              {headerContent}
              <BlockSection.NestedBlock>
                {primaryButton}
              </BlockSection.NestedBlock>
            </Column>
          </Row>
        </Section>
      </SectionContainer>
    );
  },
);

HeroBlock3.displayName = "HeroBlock3";
